import { dotComNielsenData } from 'constants';

export default {
    omniture: {
        countryRegion: 'en-us',
        hier1: 'watch:index',
        section: 'watch',
        pageName: 'watch:index',
        sections: 'watch:index',
        site: 'espn',
        premium: 'premium-no',
        convrSport: 'watch',
        pageURL: 'www.espn.com/watch/index',
        lang: 'en_us',
        contentType: 'index',
        sport: 'watch',
        account: 'wdgespcom',
        siteType: 'full',
        prop58: 'isIndex=true'
    },
    chartbeat: {
        loadPubJS: false,
        path: '/watch/index',
        zone: 'www.espn.com.us.watch',
        domain: 'www.espn.com',
        loadVidJS: true,
        title: 'WatchESPN: Live Sports, Game Replays, Video Highlights',
        sections: 'watch',
        authors: 'index'
    },
    nielsen: dotComNielsenData,
    ABTest: {
        isOptimizied: true,
        environment: 'prod',
        tScript: 'http://a.espncdn.com/prod/scripts/analytics/target.20.r2.js',
        abtestUser: 0,
        oScript: 'http://cdn.optimizely.com/js/310987714.js',
        targetURLs: [
            {
                regexp: '(/)',
                site: 'espn.co.uk',
                flag: false
            },
            {
                regexp: '(/.*)',
                site: 'www.espn.com',
                flag: false
            }
        ],
        domain: 'www.espn.com',
        host: 'espn.com',
        raw: '{\'fastcast\':{\'placements\':{\'/nba/index\':\'true\',\'^/.+$\':\'false\',\'/ncf/index\':\'true\'},\'enabled\':false,\'script\':\'http://a.espncdn.com/combiner/c?js=analytics/espn.fastcastTracking.4.js\'},\'optimizely\':{\'oldscript\':\'http://a.espncdn.com/sports/optimizely.js\',\'placements\':[{\'regexp\':\'(/)\',\'site\':\'espn.co.uk\',\'flag\':true},{\'regexp\':\'(/.*)\',\'site\':\'www.espn.com\',\'flag\':true},{\'regexp\':\'(/.*)\',\'site\':\'www.espnqa.com\',\'flag\':true}],\'enabled\':true,\'script\':\'http://cdn.optimizely.com/js/310987714.js\'},\'target\':{\'placements\':[{\'regexp\':\'(/)\',\'site\':\'espn.co.uk\',\'flag\':false},{\'regexp\':\'(/.*)\',\'site\':\'www.espn.com\',\'flag\':false}],\'enabled\':false,\'script\':\'http://a.espncdn.com/prod/scripts/analytics/target.20.r2.js\'}}',
        optimizely: true,
        target: false,
        optimizelyURLs: [
            {
                regexp: '(/)',
                site: 'espn.co.uk',
                flag: true
            },
            {
                regexp: '(/.*)',
                site: 'www.espn.com',
                flag: true
            },
            {
                regexp: '(/.*)',
                site: 'www.espnqa.com',
                flag: true
            }
        ]
    },
    isFeaturePhone: false,
    device: 'desktop',
    cto: true
};



// WEBPACK FOOTER //
// ./server/templates/dotComAnalyticsStub.js